// import { sysPath, moveFile, kill } from '../../services/fileOps'
// import { resize } from '../../services/pictOps'
import {genId} from '../utils'
// import Marker from './marker'
import {MISC_IMG} from '../Data/typeDirs'
// const {} = typeDirs
// import {genEntityName} from '../Services/filenameUtils'

const DROPDIR = '/MetaStoryFiles'
const ARCHDIR = '/Archive'

const PHOTOS_SM = 'photos_sm'
const PHOTOS = 'photos'
// const LOC_ROOT = `${app.getPath('userData')}/photo_store`


export default class MiscImage {

  constructor(args){
    // args.data = args.data?args.data:{tree:{}}
    this._id = (args&&args._id)?args._id:genId()
    this.name = (args&&args.name)?args.name:''
    this.type = (args&&args.type)?args.type:'misc'
    // this.name = this.name
  }

  static getIndices() {
    return '_id,name,[_id+name],type'
  }

  static getTypeDir(){
    return MISC_IMG
  }

  getName(){
    return `${this._id}_sm.jpg`
  }

  
  getDropboxPath(){
    return `${DROPDIR}/${MISC_IMG}/${PHOTOS_SM}/${this._id}_sm.jpg`
  }
  
  static getDropboxPath(id){
    return `${DROPDIR}/${MISC_IMG}/${PHOTOS_SM}/${id}_sm.jpg`
  }

  static getDropboxArchivePath(id){
    return `${ARCHDIR}/${MISC_IMG}/${PHOTOS}/${id}.jpg`
  }
  
  getLocalPath(localRoot, dontReplace = false){
    // if(!finsp) finsp = await dataSource[INSP_FIN].get({_id:this._inspectionFinished})
    // const ent = genEntityName(finsp.name, finsp._id)
    const locPath = `${localRoot}/${MISC_IMG}/${PHOTOS_SM}`
    let res = `${locPath}/${this._id}_sm.jpg`
    return !dontReplace?res.replace(/\\/g, "/"):res
  }

  static getLocalPath(localRoot, dontReplace = false, id){
    // if(!finsp) finsp = await dataSource[INSP_FIN].get({_id:this._inspectionFinished})
    // const ent = genEntityName(finsp.name, finsp._id)
    const locPath = `${localRoot}/${MISC_IMG}/${PHOTOS_SM}`
    let res = `${locPath}/${id}_sm.jpg`
    return !dontReplace?res.replace(/\\/g, "/"):res
  }

  getTree(){
    return this.content.getData().data.tree
  }

  tryGetAttr(attr){
    let tree = this.getTree()
    return tree[attr]&&tree[attr].content.length?tree[attr].content[0]._name:'NOT FOUND'
    // if(!res) res = 'WHOOPS'

  }

  serialize(){
    // let {_id, _inspectionFinished, _inspection, [`!picLoc`]:picLoc} = this.getIds()

    // let _parent = superSerialized.content['data'].source.parentId
    // if( Array.isArray(_parent) ) _parent = _parent[0]
    let {
      _id,
      name,
      type
    } = this


    return {
      _id,
      name,
      type
    }
  }

  static async addToMetaStoryFromDBG(dbg_id, _id, get, downloadPhoto, receiveImage, user){
    console.log('got misc img to put to dbg', _id)
    // proj = new Report(proj)

    let res = await downloadPhoto({id:dbg_id}, user)
    // console.log('from downloadPhoto', res)
    // let buff = await res.buffer()
    await receiveImage(_id, `${MISC_IMG}`, res.buffer, user, false, false)
  }

}
